const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M12 17.885a.75.75 0 0 0 .306-.065l.19-.123.035-.032 6.25-6.249a.751.751 0 1 0-1.063-1.062L12.75 15.32V3.387a.751.751 0 0 0-1.502 0V15.32l-4.967-4.966a.751.751 0 1 0-1.062 1.062l6.249 6.249.002.002a.75.75 0 0 0 .53.218m-7.234 2.351a.75.75 0 0 0 .75.746l12.933-.012a.75.75 0 0 0-.001-1.5l-12.933.012a.75.75 0 0 0-.749.754"/></svg>';
export {
  a as w
};
